<template>
  <component :is="tag" :class="classList"><slot /></component>
</template>
<script>
export default {
  name: "UiHeadline",
  props: {
    tag: {
      type: String,
      default: "h3"
    },
    theme: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: null,
    }
  },

  computed: {
    classList() {
      return {
        headline: true,
        [`headline--${this.size}`]: this.size,
        [`headline--${this.theme}`]: this.theme,
        [`headline--${this.align}`]: this.align
      };
    }
  }
};
</script>
